import React from "react";

import { inject, observer } from "mobx-react";

import { PermissionsController } from "../../PermissionsController";

@inject("permissionsController")
@observer
export class PermissionCheckbox extends React.Component<{
  permissionsController?: PermissionsController;
  type: "past" | "current" | "future";
  selectAll?: boolean;
  record?: any;
}> {
  private handleOnChange = (e) => {
    const val = e.target.checked;

    this.props.record[this.props.type] = val;
  };

  renderCheckbox() {
    return <input type="checkbox" checked={this.props.record[this.props.type]} onChange={(e) => this.handleOnChange(e)} />;
  }

  public render() {
    return this.renderCheckbox();
  }
}
